module.exports = __webpack_public_path__ + "img/app.3854246b.svg";